import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SortChangeEvent {
    key: string;
    order: 'asc' | 'desc';
}

/**
 * Reusable sortable column header, extracted from the 3-state sort cycle
 * (unsorted -> desc -> asc -> unsorted) already used by LoansTableComponent
 * and manage-user/all-user, so pages gaining sort for the first time render
 * and behave identically instead of re-implementing this per page.
 *
 * Usage inside a <th>:
 *   <th class="sortable">
 *     <app-sortable-header label="Name" sortKey="name" [activeSortKey]="sortKey"
 *       [activeSortOrder]="sortOrder" (sortChange)="onSortChange($event)"></app-sortable-header>
 *   </th>
 */
@Component({
    selector: 'app-sortable-header',
    templateUrl: './sortable-header.component.html',
    styleUrls: ['./sortable-header.component.scss'],
    standalone: false
})
export class SortableHeaderComponent {
    @Input() label = '';
    @Input() sortKey = '';
    @Input() activeSortKey = '';
    @Input() activeSortOrder: 'asc' | 'desc' = 'desc';

    @Output() sortChange = new EventEmitter<SortChangeEvent>();

    public onSortColumn(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        if (this.activeSortKey === this.sortKey) {
            if (this.activeSortOrder === 'desc') {
                this.sortChange.emit({ key: this.sortKey, order: 'asc' });
                return;
            }
            this.sortChange.emit({ key: '', order: 'desc' });
            return;
        }
        this.sortChange.emit({ key: this.sortKey, order: 'desc' });
    }
}
